import React from 'react';

/**
 * Customer-facing shipment tracking block.
 * @param {{ tracking_number?: string|null, tracking_url?: string|null, tracking_carrier_name?: string|null, className?: string, compact?: boolean }} props
 */
export default function CustomerShipmentTracking({
  tracking_number: trackingNumber,
  tracking_url: trackingUrl,
  tracking_carrier_name: carrierName,
  className = '',
  compact = false,
}) {
  const awb = String(trackingNumber || '').trim();
  const url = String(trackingUrl || '').trim();
  const carrier = String(carrierName || '').trim();

  if (!awb && !url) {
    return null;
  }

  if (compact) {
    const parts = [];
    if (carrier) parts.push(`via ${carrier}`);
    if (awb) parts.push(`AWB ${awb}`);
    return (
      <span className={`customer-shipment-tracking customer-shipment-tracking--compact ${className}`.trim()}>
        Shipped {parts.join(' · ')}
      </span>
    );
  }

  const trackLabel = carrier ? `Track on ${carrier}` : 'Track package';

  return (
    <div
      className={`customer-shipment-tracking ${className}`.trim()}
      role="region"
      aria-label="Shipment tracking"
    >
      <p className="customer-shipment-tracking__lead mb-2">
        <strong>Your order has shipped</strong>
        <span className="d-block small text-muted fw-normal mt-1">
          Use the details below to follow your package on the courier&apos;s website.
        </span>
      </p>
      <dl className="customer-shipment-tracking__details mb-0">
        {carrier ? (
          <>
            <dt className="customer-shipment-tracking__label">Courier</dt>
            <dd className="customer-shipment-tracking__value">{carrier}</dd>
          </>
        ) : null}
        {awb ? (
          <>
            <dt className="customer-shipment-tracking__label">Tracking number (AWB)</dt>
            <dd className="customer-shipment-tracking__value">
              <code className="customer-shipment-tracking__awb">{awb}</code>
            </dd>
          </>
        ) : null}
      </dl>
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline-primary btn-sm rounded-pill mt-3 customer-shipment-tracking__cta"
        >
          {trackLabel}
        </a>
      ) : awb ? (
        <p className="small text-muted mb-0 mt-2">
          Copy the AWB above and paste it on your courier&apos;s tracking page when a link is not available.
        </p>
      ) : null}
    </div>
  );
}
